import GLOBALS from "../utils/Globals"

// Debug logging for environment detection
console.log("🔍 Environment Detection Debug:");
console.log("process.env.REACT_APP_ENV:", process.env.REACT_APP_ENV);
console.log("NODE_ENV:", process.env.NODE_ENV);

// More explicit environment detection
const isProd = process.env.REACT_APP_ENV === "PROD" ||
               process.env.REACT_APP_ENV === "production" ||
               process.env.NODE_ENV === "production";

const baseURL = isProd ? GLOBALS.PROD.baseURL : GLOBALS.DEV.baseURL;

console.log("🎯 Selected baseURL:", baseURL);
console.log("🎯 Using PROD config:", isProd);

export default baseURL;
